import * as z from "zod";

export const inquiryTypes = [
  "sales",
  "demo",
  "integration",
  "brand",
  "partnership",
  "support",
  "other",
] as const;
export type InquiryType = (typeof inquiryTypes)[number];

const contactInquiryObjectSchema = z.object({
  name: z.string().trim().min(2).max(100),
  email: z.string().trim().email().max(200),
  company: z.string().trim().max(150).optional().default(""),
  country: z.string().trim().min(2).max(100),
  phone: z.string().trim().max(50).optional(),
  inquiryType: z.enum(inquiryTypes),
  message: z.string().trim().min(10).max(3000),
  consent: z.literal(true),
  source: z.string().trim().min(1).max(80),
});

function requireCompany(
  value: { company: string; inquiryType: InquiryType },
  context: z.RefinementCtx,
) {
  if (value.inquiryType !== "support" && value.company.length === 0) {
    context.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Company is required for this inquiry type",
      path: ["company"],
    });
  }
}

export const contactInquirySchema = contactInquiryObjectSchema.superRefine(requireCompany);

export const contactRequestSchema = contactInquiryObjectSchema
  .extend({
    website: z.string().max(200).optional().default(""),
  })
  .superRefine(requireCompany);

export const contactFormSchema = contactInquiryObjectSchema
  .extend({
    consent: z.boolean().refine((value) => value, "Required"),
    website: z.string().max(200).optional().default(""),
  })
  .superRefine(requireCompany);

export type ContactInquiry = z.infer<typeof contactInquirySchema>;
export type ContactRequest = z.infer<typeof contactRequestSchema>;

export function isInquiryType(value: string | null | undefined): value is InquiryType {
  return inquiryTypes.includes(value as InquiryType);
}
